import React from "react";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../Benefit/Point/PointTab";

export const tempAccountTabState = atom<number>({
  key: "tempAccountTabState",
  default: 0,
});

export default function TempAccountTab() {
  const [tab, setTab] = useRecoilState(tempAccountTabState);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>
          임시 계정 관리
        </PointTabText>

        <PopupTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>
          임시 계정 발급 내역
        </PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const PopupTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 103 : 140)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : 122)}px;
`;
